import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types/swiper-options';
import WindowSize from '../singleton/WindowSize';

class ResponsiveSwiper {
  $block: JQuery<HTMLElement>;
  $swiper: JQuery<HTMLElement>;
  instance: Swiper | null;
  options: SwiperOptions;
  breakpoint: number;
  windowSize: WindowSize;
  onResizeBound: (width: number) => void;

  constructor(
    el: HTMLElement | JQuery<HTMLElement>,
    options = {
      slidesPerView: 'auto',
      speed: 500,
    } as SwiperOptions,
    breakpoint = 768
  ) {
    this.$block = $(el);
    this.$swiper = this.$block.hasClass('swiper')
      ? this.$block
      : this.$block.find('.swiper');
    this.instance = null;
    this.options = options;
    this.breakpoint = breakpoint;
    this.windowSize = WindowSize.getInstance();
    this.onResizeBound = this.onResize.bind(this);
    this.windowSize.addListener(this.onResizeBound);

    this.init();
  }

  init() {
    if (this.windowSize.getSize().width < this.breakpoint && !this.instance) {
      this.instance = new Swiper(this.$swiper[0], this.options);
    }
  }

  destroy() {
    if (this.instance) {
      this.instance.destroy(true, true);
      this.instance = null;
    }
  }

  onResize(width: number) {
    if (width < this.breakpoint) {
      this.init();
      return;
    }

    this.destroy();
  }

  teardown() {
    this.destroy();
    this.windowSize.removeListener(this.onResizeBound);
  }
}

export default ResponsiveSwiper;
